import React, { Component } from 'react';
import _ from 'lodash';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Auth } from '@aws-amplify/auth';
import log from 'loglevel';
import LoginModal from './user/LoginModal';

const staleTime = 60000;

const { Consumer, Provider } = React.createContext('authentication');

export const transformUser = (user) => {
  user = user || {};
  return {
    username: user.username,
    isAdmin: _.includes(
      _.get(user, [
        'signInUserSession',
        'accessToken',
        'payload',
        'cognito:groups',
      ]) || [],
      'admin',
    ),
    isLoggedIn: _.has(user, ['attributes', 'sub']),
  };
};

export const resolveCurrentUser = async () => {
  const credentials = await Auth.currentCredentials();
  const { identityId } = credentials;
  let curUser;
  try {
    curUser = await Auth.currentAuthenticatedUser();
  } catch (err) {
    // User is not logged in
  }
  const User = { identityId, ...transformUser(curUser) };
  log.debug({ User }, 'resolved user');
  return User;
};

const Authentication = ({ children }) => {
  const queryClient = useQueryClient();

  const [LoginModalRendered, setModalOpen] = LoginModal();
  const handleLoginClick = _.partial(setModalOpen, true);

  const logoutMutation = useMutation(async () => Auth.signOut(), {
    onSuccess: () => {
      log.debug('signed out successfully');
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      queryClient.invalidateQueries({ queryKey: ['GetCart'] });
    },
  });
  const User = useQuery(['currentUser'], resolveCurrentUser, { staleTime });

  return (
    <Provider
      value={{ User, LoginModalRendered, handleLoginClick, logoutMutation }}
    >
      {children}
    </Provider>
  );
};

Authentication.Consumer = Consumer;
Authentication.Provider = Authentication;

export default { Consumer, Provider: Authentication };
